import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Global crash reporter ────────────────────────────────────────────────
// Captures uncaught errors and unhandled promise rejections that don't go
// through a React render cycle (async event handlers, setTimeout callbacks,
// misbehaving fetch chains). Reports them to /api/client-errors with the
// same shape as ErrorBoundary so we can investigate after the fact.
// Tom Clancy 2026-04-30: PMs reporting silent crashes; this gives us logs.
(function installCrashReporter() {
  if (typeof window === 'undefined') return;
  if (window.__acsCrashReporterInstalled) return;
  window.__acsCrashReporterInstalled = true;

  const seen = new Set();
  function report(payload) {
    try {
      // De-dupe identical errors fired in tight loops (e.g. animation
      // frames) so we don't DDoS our own log endpoint.
      const key = (payload.message || '') + '|' + (payload.stack || '').slice(0, 200);
      if (seen.has(key)) return;
      seen.add(key);
      setTimeout(() => seen.delete(key), 10000);

      const token = localStorage.getItem('token');
      fetch('/api/client-errors', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: 'Bearer ' + token } : {}),
        },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => { /* swallow */ });
    } catch (_) { /* swallow */ }
  }

  window.addEventListener('error', (e) => {
    report({
      message: String(e.message || ''),
      stack: String((e.error && e.error.stack) || ''),
      url: window.location.href,
      path: window.location.pathname,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      boundary: 'window.error',
      source_file: e.filename || null,
      line: e.lineno || null,
      col: e.colno || null,
    });
  });

  window.addEventListener('unhandledrejection', (e) => {
    const reason = e.reason;
    report({
      message: String((reason && reason.message) || reason || 'unhandled rejection'),
      stack: String((reason && reason.stack) || ''),
      url: window.location.href,
      path: window.location.pathname,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      boundary: 'unhandledrejection',
    });
  });
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
